<template>
  <div class="content">
    <!-- 主要内容区 -->
    <main class="max-w-7xl mx-auto px-4 py-8">
      <!-- 数据概览 -->
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-green-100 text-green-600">
              <i class="fas fa-calendar-check text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">进行中活动</p>
              <p class="text-2xl font-bold">12</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-blue-100 text-blue-600">
              <i class="fas fa-users text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">活动参与人数</p>
              <p class="text-2xl font-bold">45,678</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-purple-100 text-purple-600">
              <i class="fas fa-heart text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">互动量</p>
              <p class="text-2xl font-bold">89,432</p>
            </div>
          </div>
        </div>
        <div class="bg-white rounded-lg shadow-md p-6">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-yellow-100 text-yellow-600">
              <i class="fas fa-chart-line text-xl"></i>
            </div>
            <div class="ml-4">
              <p class="text-gray-500">转化率</p>
              <p class="text-2xl font-bold">23.5%</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 活动列表 -->
      <div class="bg-white rounded-lg shadow-md p-6 mb-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-xl font-bold">活动列表</h2>
          <div class="flex space-x-4">
            <select class="border rounded-lg px-4 py-2 focus:outline-none focus:border-green-500">
              <option>所有状态</option>
              <option>进行中</option>
              <option>已结束</option>
              <option>未开始</option>
            </select>
            <button class="bg-gray-100 px-4 py-2 rounded-lg hover:bg-gray-200">
              <i class="fas fa-filter mr-2"></i>筛选
            </button>
          </div>
        </div>

        <!-- 活动卡片 -->
        <div class="space-y-6">
          <!-- 活动1 -->
          <div class="border rounded-lg p-6">
            <div class="flex justify-between items-start mb-4">
              <div>
                <h3 class="text-xl font-bold">王者荣耀排位赛</h3>
                <p class="text-gray-600">活动时间：2024-03-20 至 2024-03-27</p>
              </div>
              <span class="bg-green-100 text-green-600 px-3 py-1 rounded-full text-sm">进行中</span>
            </div>
            <div class="grid grid-cols-4 gap-4 mb-4">
              <div>
                <p class="text-gray-500 text-sm">参与主播</p>
                <p class="font-bold">12人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">参与观众</p>
                <p class="font-bold">8,432人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">互动量</p>
                <p class="font-bold">23,456</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">转化率</p>
                <p class="font-bold">15.8%</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="flex space-x-2">
                <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 text-sm">
                  <i class="fas fa-eye mr-1"></i>查看详情
                </button>
                <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                  <i class="fas fa-edit mr-1"></i>编辑活动
                </button>
              </div>
              <div class="text-right">
                <p class="text-sm text-gray-500">剩余时间</p>
                <p class="font-bold text-green-600">3天12小时</p>
              </div>
            </div>
          </div>

          <!-- 活动2 -->
          <div class="border rounded-lg p-6">
            <div class="flex justify-between items-start mb-4">
              <div>
                <h3 class="text-xl font-bold">美食探店挑战</h3>
                <p class="text-gray-600">活动时间：2024-03-15 至 2024-03-22</p>
              </div>
              <span class="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm">进行中</span>
            </div>
            <div class="grid grid-cols-4 gap-4 mb-4">
              <div>
                <p class="text-gray-500 text-sm">参与主播</p>
                <p class="font-bold">8人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">参与观众</p>
                <p class="font-bold">5,678人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">互动量</p>
                <p class="font-bold">18,234</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">转化率</p>
                <p class="font-bold">12.3%</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="flex space-x-2">
                <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 text-sm">
                  <i class="fas fa-eye mr-1"></i>查看详情
                </button>
                <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                  <i class="fas fa-edit mr-1"></i>编辑活动
                </button>
              </div>
              <div class="text-right">
                <p class="text-sm text-gray-500">剩余时间</p>
                <p class="font-bold text-blue-600">1天8小时</p>
              </div>
            </div>
          </div>

          <!-- 活动3 -->
          <div class="border rounded-lg p-6">
            <div class="flex justify-between items-start mb-4">
              <div>
                <h3 class="text-xl font-bold">音乐翻唱大赛</h3>
                <p class="text-gray-600">活动时间：2024-03-25 至 2024-04-01</p>
              </div>
              <span class="bg-yellow-100 text-yellow-600 px-3 py-1 rounded-full text-sm">未开始</span>
            </div>
            <div class="grid grid-cols-4 gap-4 mb-4">
              <div>
                <p class="text-gray-500 text-sm">参与主播</p>
                <p class="font-bold">15人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">参与观众</p>
                <p class="font-bold">12,345人</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">互动量</p>
                <p class="font-bold">34,567</p>
              </div>
              <div>
                <p class="text-gray-500 text-sm">转化率</p>
                <p class="font-bold">18.9%</p>
              </div>
            </div>
            <div class="flex justify-between items-center">
              <div class="flex space-x-2">
                <button class="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 text-sm">
                  <i class="fas fa-eye mr-1"></i>查看详情
                </button>
                <button class="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 text-sm">
                  <i class="fas fa-edit mr-1"></i>编辑活动
                </button>
              </div>
              <div class="text-right">
                <p class="text-sm text-gray-500">开始时间</p>
                <p class="font-bold text-yellow-600">5天后</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ContentPage',
  data() {
    return {
      // 数据概览
      overviewData: {
        ongoingActivities: 12,
        participants: 45678,
        interactions: 89432,
        conversionRate: '23.5%'
      }
    }
  }
}
</script>

<style scoped>
.content {
  background: #f5f5f5;
  min-height: calc(100vh - 64px);
}

.card-hover {
  transition: all 0.3s ease;
}

.card-hover:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.1);
}

.grid {
  display: grid;
}

.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

.gap-6 {
  gap: 1.5rem;
}

.mb-8 {
  margin-bottom: 2rem;
}

.mb-6 {
  margin-bottom: 1.5rem;
}

.mb-4 {
  margin-bottom: 1rem;
}

.p-6 {
  padding: 1.5rem;
}

.p-3 {
  padding: 0.75rem;
}

.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.ml-4 {
  margin-left: 1rem;
}

.mr-2 {
  margin-right: 0.5rem;
}

.mr-1 {
  margin-right: 0.25rem;
}

.text-xl {
  font-size: 1.25rem;
}

.text-2xl {
  font-size: 1.5rem;
}

.font-bold {
  font-weight: 700;
}

.text-gray-500 {
  color: #6b7280;
}

.text-gray-600 {
  color: #4b5563;
}

.text-green-600 {
  color: #16a34a;
}

.text-blue-600 {
  color: #2563eb;
}

.text-purple-600 {
  color: #9333ea;
}

.text-yellow-600 {
  color: #ca8a04;
}

.bg-green-100 {
  background-color: #dcfce7;
}

.bg-blue-100 {
  background-color: #dbeafe;
}

.bg-purple-100 {
  background-color: #f3e8ff;
}

.bg-yellow-100 {
  background-color: #fef3c7;
}

.bg-gray-100 {
  background-color: #f3f4f6;
}

.rounded-lg {
  border-radius: 0.5rem;
}

.rounded-full {
  border-radius: 9999px;
}

.shadow-md {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.border {
  border-width: 1px;
}

.focus\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\:border-green-500:focus {
  border-color: #16a34a;
}

.hover\:bg-green-700:hover {
  background-color: #15803d;
}

.hover\:bg-blue-700:hover {
  background-color: #1d4ed8;
}

.hover\:bg-gray-200:hover {
  background-color: #e5e7eb;
}

.text-white {
  color: #ffffff;
}

.bg-green-600 {
  background-color: #16a34a;
}

.bg-blue-600 {
  background-color: #2563eb;
}

.text-sm {
  font-size: 0.875rem;
}

.space-y-6 > * + * {
  margin-top: 1.5rem;
}

.flex {
  display: flex;
}

.items-center {
  align-items: center;
}

.justify-between {
  justify-content: space-between;
}

.items-start {
  align-items: flex-start;
}

.flex-wrap {
  flex-wrap: wrap;
}

.gap-4 {
  gap: 1rem;
}

.space-x-4 > * + * {
  margin-left: 1rem;
}

.space-x-2 > * + * {
  margin-left: 0.5rem;
}

.relative {
  position: relative;
}

.absolute {
  position: absolute;
}

.left-3 {
  left: 0.75rem;
}

.top-3 {
  top: 0.75rem;
}

.w-full {
  width: 100%;
}

.pl-10 {
  padding-left: 2.5rem;
}

.pr-4 {
  padding-right: 1rem;
}

.text-gray-400 {
  color: #9ca3af;
}

.text-right {
  text-align: right;
}

.grid-cols-4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (min-width: 768px) {
  .md\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1024px) {
  .lg\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
</style> 